__turbopack_context__.v({
  "loader": "BRC7pW_loader",
  "prixClipFix": "BRC7pW_prixClipFix",
  "pulse": "BRC7pW_pulse",
  "rotate": "BRC7pW_rotate",
});
